import React, { useState, useRef, useEffect } from 'react';
import './FiltreLois.css';

const FiltreLois = ({ onFilterChange, initialFilters }) => {
    const [isTypeDropdownOpen, setIsTypeDropdownOpen] = useState(false);
    const [filters, setFilters] = useState(initialFilters || {
        inForce: true,
        date: false,
        selectedTypes: []
    });

    const dropdownRef = useRef(null);

    const lawTypes = [
        "Code",
        "Ordonnance",
        "Décret",
        "Loi",
        "Arrêté",
        "Décret loi",
        "Constitution",
        "Traité",
        "Acte uniforme"
    ];

    useEffect(() => {
        // Close dropdown when clicking outside
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsTypeDropdownOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const toggleFilter = (filterType) => {
        const updatedFilters = { ...filters };

        if (filterType === 'inForce' || filterType === 'date') {
            updatedFilters[filterType] = !updatedFilters[filterType];
        }

        setFilters(updatedFilters);
        onFilterChange(updatedFilters);
    };

    const toggleTypeDropdown = () => {
        setIsTypeDropdownOpen(!isTypeDropdownOpen);
    };

    const toggleTypeSelection = (type) => {
        const updatedFilters = { ...filters };
        const typeIndex = updatedFilters.selectedTypes.indexOf(type);

        if (typeIndex === -1) {
            updatedFilters.selectedTypes.push(type);
        } else {
            updatedFilters.selectedTypes.splice(typeIndex, 1);
        }

        setFilters(updatedFilters);
        onFilterChange(updatedFilters);
    };

    return (
        <div className="filtres-container">
            {/* <div className="filtres-label">Filtres</div> */}
            <div className="filtres-buttons">
                <button
                    className={`filtre-button ${filters.inForce ? 'active' : ''}`}
                    onClick={() => toggleFilter('inForce')}
                >
                    En vigueur
                </button>

                <button
                    className={`filtre-button ${filters.date ? 'active' : ''}`}
                    onClick={() => toggleFilter('date')}
                >
                    <svg className="filtre-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                        <line x1="16" y1="2" x2="16" y2="6"></line>
                        <line x1="8" y1="2" x2="8" y2="6"></line>
                        <line x1="3" y1="10" x2="21" y2="10"></line>
                    </svg>
                    Date
                </button>

                <div className="dropdown-container" ref={dropdownRef}>
                    <button
                        className={`filtre-button ${filters.selectedTypes.length > 0 ? 'active' : ''}`}
                        onClick={toggleTypeDropdown}
                    >
                        <svg className="filtre-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
                        </svg>
                        Type
                    </button>

                    {isTypeDropdownOpen && (
                        <div className="type-dropdown">
                            {lawTypes.map((type) => (
                                <div key={type} className="type-option">
                                    <label className="type-label">
                                        <input
                                            type="checkbox"
                                            checked={filters.selectedTypes.includes(type)}
                                            onChange={() => toggleTypeSelection(type)}
                                        />
                                        {type}
                                    </label>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default FiltreLois;